<template>
    <section :class="css.container">
        <div :class="css.header">
            <div class="container" :class="css.header_body">
                <h2 :class="css.title" class="font-variable color-1 font-bold">{{ $t("References") }}</h2>
                <UiTooltip :zIndex="68" :width="600" direction="bottom" align="start" :classExtraName="css_normalize.tip">
                    <img src="https://rdgta.cdn.cyagen.com/rddc/pictures/d586af8e-2537-4f6f-b2a2-916bb995763a.webp" alt="" />
                    <template #content>
                        <div :class="css_normalize.context">{{ $t("ModelReferencesDesc1") }}</div>
                        <div :class="css_normalize.context">{{ $t("ModelReferencesDesc2") }}</div>
                    </template>
                </UiTooltip>
            </div>
        </div>

        <related-references :id="$route.params.id?.toString()" mode="model" />
    </section>
</template>

<script lang="ts" setup>
//* 组件库
import { UiTooltip } from "various-ui";
//* 局部公共组件
import RelatedReferences from "@/views/details/components/related-references/index.vue";
//* 样式
import css from "./style/index.module.less";
import css_normalize from "@/assets/style/src/index.module.less";
</script>
